import type { ScheduleModeConfig } from '../types';

export const adhocModeConfig: ScheduleModeConfig = {
  key: 'adhoc',
  navigationStyle: 'stepper',
  steps: [
    { key: 'details', label: 'Details' },
    { key: 'communication', label: 'Invites & emails' },
    { key: 'scorecard', label: 'Scorecard' },
  ],
  showSecondaryCta: false,
};
